import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import routerConstant from "service/constant/routerConstant";

interface Props {
  data: any;
  count: number;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  selectTable: string[];
  setSelectTable: React.Dispatch<React.SetStateAction<string[]>>;
}

const CustomTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
  }
  .ant-table-tbody > tr > td {
    color: #111827;
    font-size: 14px;
  }
  .routerBtn {
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export function ListTable({
  data,
  count,
  page,
  setPage,
  selectTable,
  setSelectTable,
}: Props) {
  const navigate = useNavigate();

  const typeMap: { [key: string]: any } = {
    1: "이용약관",
    2: "개인정보 처리방침",
    3: "보호자 동의약관",
    4: "정기 결제 약관",
    5: "환불 규정",
    6: "결제사 정보 제공",
  };

  const handleDetailBtn = (id: string) => {
    navigate(`${routerConstant.terms}/${id}`);
  };

  const columns = [
    {
      title: "NO",
      dataIndex: "id",
      width: "7%",
    },
    {
      title: "구분",
      dataIndex: "type",
      width: "23%",
      render: (type: string) => <>{typeMap[type]}</>,
    },
    {
      title: "제목",
      dataIndex: "title",
    },
    {
      title: "상세보기",
      dataIndex: "id",
      width: "10%",
      render: (text: string) => (
        <span className="routerBtn" onClick={() => handleDetailBtn(text + "")}>
          바로가기
        </span>
      ),
    },
  ];

  const handleSelectTableChange = (selectTable: any) => {
    setSelectTable(selectTable);
  };

  const rowSelection: any = {
    selectedRowKeys: selectTable,
    onChange: handleSelectTableChange,
  };

  return (
    <CustomTable
      rowKey="id"
      rowSelection={rowSelection}
      columns={columns}
      dataSource={data}
      pagination={{
        current: page,
        pageSize: 30,
        onChange: (page) => setPage(page),
        total: count,
      }}
    />
  );
}
